import { itemThumbUrl } from './itemArt';
import { PANEL_ROWS, rowText } from './scans';
import type { Group } from './types';

/**
 * The details panel for one location, built from DOM nodes and text only: names and item
 * names come from players and the catalog, so nothing here is ever parsed as HTML.
 */
export function buildPopup(group: Group, onPickPlayer: (playerId: string, label: string) => void): HTMLElement {
  const root = document.createElement('div');
  root.className = 'panel';
  const rows = group.scans.slice(0, PANEL_ROWS);
  for (const scan of rows) {
    const t = rowText(scan);
    const row = document.createElement('div');
    row.className = 'panel-row';

    const when = document.createElement('div');
    when.className = 'when';
    when.textContent = t.local;
    const utc = document.createElement('div');
    utc.className = 'utc';
    utc.textContent = t.utc;

    const who = document.createElement('div');
    const name = document.createElement('button');
    name.type = 'button';
    name.className = 'player-link';
    name.textContent = t.player;
    name.addEventListener('click', () => onPickPlayer(t.playerId, t.player));
    who.append(name);

    const what = document.createElement('div');
    what.className = 'what';
    what.textContent = t.what;

    const text = document.createElement('div');
    text.className = 'row-text';
    text.append(when, utc, who, what);
    row.append(text);

    const thumbUrl = scan.result === 'found' ? itemThumbUrl(scan.itemId) : null;
    if (thumbUrl) {
      const img = document.createElement('img');
      img.className = 'thumb';
      img.src = thumbUrl;
      img.alt = '';
      img.width = 48;
      img.height = 48;
      row.prepend(img);
    }

    if (t.outcome) {
      const outcome = document.createElement('div');
      outcome.className = `outcome outcome-${scan.outcome}`;
      outcome.textContent = t.outcome;
      text.append(outcome);
    }
    root.append(row);
  }
  const more = group.scans.length - rows.length;
  if (more > 0) {
    const el = document.createElement('div');
    el.className = 'more';
    el.textContent = `and ${more} more`;
    root.append(el);
  }
  return root;
}
